declare namespace $ {

	export class $bog_popup_plugin extends $mol_plugin {
	}
	
}

//# sourceMappingURL=popup.view.tree.d.ts.map